import { IListItem } from "@nkr/models/list-item";
import { Button, FormControl } from "react-bootstrap";
import { IDonorConnectGroup, IDonorConnectSurveyType, IGroup } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    startDate: string,
    endDate: string,
    mentorId: number,
    group: IGroup,
    donorConnectGroup: IDonorConnectGroup,
    donorConnectSurveyType: IDonorConnectSurveyType,
    organType: OrganType | null,
    mentorList: { id: number, firstName: string, lastName: string, donorConnectCaseLoad: number }[],
    onDateChange: (name: string, value: string) => void,
    onMentorChange: (coachId: number) => void,
    onGroupChange: (e: React.FormEvent<HTMLInputElement>) => void,
    onTypeChange: (e: React.FormEvent<HTMLButtonElement>) => void,
    onOrganTypeChange: (organType: OrganType | null) => void,
    onSearch: () => void,
    onExport: () => void
}

const Filters = (props: IProps) => {
    const handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        props.onDateChange(name, value);
    };

    const handleMentorChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onMentorChange(parseInt(e.currentTarget.value));
    };


    const handleGroupChange = (e: React.FormEvent<HTMLInputElement>) => {
        props.onGroupChange(e);
    }

    const handleTypeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        props.onTypeChange(e);
    }

    const isSuperUser = props.group.isSuper;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
            <div style={{ display: 'flex' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10, marginLeft: 10 }}>
                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                    <div>
                        <FormControl
                            type='date'
                            name='startDate'
                            value={props.startDate}
                            onChange={handleDateChange}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>End Date:</div>
                    <div>
                        <FormControl
                            type='date'
                            name='endDate'
                            value={props.endDate}
                            onChange={handleDateChange}
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: '1px' }}>
                <div style={{ marginRight: 5 }}>Type:</div>
                <div className="btn-group" data-toggle="buttons" style={{ marginRight: 1 }}>
                    <button type='button' className={"btn " + (props.donorConnectSurveyType.DASH ? 'btn-primary active' : 'btn-default')} value='DASH' onClick={handleTypeChange}>PL DASH</button>
                    <button type='button' className={"btn " + (props.donorConnectSurveyType.DCN ? 'btn-primary active' : 'btn-default')} value='DCN' onClick={handleTypeChange}>DCN</button>
                    <button type='button' className={"btn " + (props.donorConnectSurveyType.NKR ? 'btn-primary active' : 'btn-default')} value='NKR' onClick={handleTypeChange}>NKR</button>
                </div>
            </div>

            {isSuperUser && (
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}>
                    <div style={{ marginRight: 5 }}>Group:</div>

                    <div className="btn-group" data-toggle="buttons" style={{ marginRight: .5 }}>
                        <input type='button' className={"btn " + (props.donorConnectGroup.Nkdo ? 'btn-primary active' : 'btn-default')} name='groups' value='Nkdo' style={{ textTransform: 'uppercase' }} onClick={handleGroupChange} />
                    </div>
                    <div className="btn-group" data-toggle="buttons" style={{ marginRight: .5 }}>
                    </div>
                    <div className="btn-group" data-toggle="buttons" style={{ marginRight: .5 }}>
                        <input type='button' className={"btn " + (props.donorConnectGroup.Nkf ? 'btn-primary active' : 'btn-default')} name='groups' value='Nkf' style={{ textTransform: 'uppercase' }} onClick={handleGroupChange} />
                    </div>
                    <div className="btn-group" data-toggle="buttons" style={{ marginRight: .5 }}>
                    </div>

                    <div className="btn-group" data-toggle="buttons" style={{ marginRight: .5 }}>
                        <input type='button' className={"btn " + (props.donorConnectGroup.Nkr ? 'btn-primary active' : 'btn-default')} name='groups' value='Nkr' style={{ textTransform: 'uppercase' }} onClick={handleGroupChange} />
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}>
                <div style={{ marginRight: 5 }}>Organ:</div>
                <div className="btn-group" data-toggle="buttons">
                    <button type='button' className={"btn " + (props.organType == null ? 'btn-primary active' : 'btn-default')} onClick={() => props.onOrganTypeChange(null)}>All</button>
                    <button type='button' className={"btn " + (props.organType === OrganType.Kidney ? 'btn-primary active' : 'btn-default')} onClick={() => props.onOrganTypeChange(OrganType.Kidney)}>Kidney</button>
                    <button type='button' className={"btn " + (props.organType === OrganType.Liver ? 'btn-primary active' : 'btn-default')} onClick={() => props.onOrganTypeChange(OrganType.Liver)}>Liver</button>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}>
                <div style={{ marginRight: 5 }}>Mentor:</div>
                <div>
                    <FormControl
                        componentClass='select'
                        value={props.mentorId}
                        onChange={handleMentorChange}
                    >
                        <option value={0}>- All Mentors -</option>
                        {props.mentorList.map(mentor =>
                            <option key={'mentor-' + mentor.id} value={mentor.id}>{mentor.lastName}, {mentor.firstName}</option>
                        )}
                    </FormControl>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ width: 150, marginRight: 5 }}>
                    <Button className='btn-block btn-md' bsStyle="primary" onClick={props.onSearch}>Search</Button>
                </div>

                <div style={{ width: 150 }}>
                    <Button bsStyle='warning' className='btn-block' onClick={props.onExport}>CSV</Button>
                </div>
            </div>
        </div>
    );
}

export default Filters;